
  var _styles = {
  "modal-city-item__outer-wrapper": {
    "width": "2.18667rem",
    "height": "2.93333rem",
    "position": "relative",
    "zIndex": 999,
    "overflow": "visible"
  },
  "modal-city-item__inner-wrapper": {
    "position": "relative",
    "zIndex": 2,
    "width": "2.18667rem",
    "height": "2.93333rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "visible"
  },
  "modal-city-item__background": {
    "position": "absolute",
    "zIndex": 1,
    "width": "2.13333rem",
    "height": "2.93333rem",
    "top": 0,
    "left": 0
  },
  "modal-city-item__city-name": {
    "position": "absolute",
    "bottom": "0.86667rem",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem",
    "zIndex": 1
  },
  "modal-city-item__button": {
    "position": "absolute",
    "bottom": "0.24rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "1.30667rem",
    "height": "0.48rem",
    "borderRadius": "0.53333rem",
    "background": "#ffed4b"
  },
  "modal-city-item__button-text": {
    "fontWeight": "400",
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem"
  },
  "modal-city-item__hand-wrapper": {
    "position": "absolute",
    "zIndex": 999,
    "width": "1.6rem",
    "height": "1.6rem",
    "right": "-0.53333rem",
    "bottom": "-0.6rem"
  }
};



  module.exports = _styles;
  